/**
 * created by tian ruo jun
 摘要
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Input, Select,Modal} from "antd";
import BaseComponent from "../../../../base/BaseComponent";

const {TextArea} = Input;
const { confirm } = Modal;
let mustFilterSummary = false;
let automaticMaxLength = 240;
let summaryMaxLength = 901;

export default class RmtTextArea extends BaseComponent {
    static defaultProps = {
        type: "text",
        onChange: () => {
        },
        value: "",
    };
    static propTypes = {
        type: PropTypes.string.isRequired,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
        mustFilterSummary = this.sysConfigGetValueByKey("must.filter.editor.summary", "0") === '1';
        automaticMaxLength = this.sysConfigGetValueByKey("automatic.max.length", "240")*1;
        summaryMaxLength = this.sysConfigGetValueByKey("summary.max.length", "901")*1;
    }

    setSummary = ({autoExtractSummary,value,contentText,onChange,field,onChangeOfState}) => {
        if(autoExtractSummary===1) {
            let val = contentText && contentText.length ? contentText : "";
            if(mustFilterSummary) {
                val = val.replace(/\s/g,'')
            }
            if(val && val.length > automaticMaxLength){
                val = val.substring(0, automaticMaxLength)+"..."
            }
            if (val != value) {
                setTimeout(() => {
                    onChange(field, val, true);
                }, 0)
            }
        } else {
            let val = value || "";
            if(mustFilterSummary) {
                val = val.replace(/\s/g,'')
            }
            if(val && val.length > summaryMaxLength){
                val = val.substring(0, summaryMaxLength)
            }
            if(val!=value){
                setTimeout(()=>{
                    onChange(field, val, true);
                },0)
            }
        }
    };

    render() {
        let {value, disabled, field, onChange, onChangeOfState, formItemSizeConfig, id, autoExtractSummary,notShowEditor} = this.props;
        if(!notShowEditor) {
            this.setSummary({autoExtractSummary,value,contentText:this.props.contentText,onChange,field,onChangeOfState});
        }
        return (
            <div style={{display:'flex'}}>
                <TextArea
                    id={id}
                    className={'rmt-textarea'}
                    size={formItemSizeConfig.inputSize}
                    rows={4}
                    maxLength={summaryMaxLength}
                    placeholder={`请输入`}
                    disabled={disabled}
                    value={value}
                    onChange={(e) => {
                        let val = e.target.value || '';
                        onChange(field, val)
                    }}
                    readOnly={autoExtractSummary===1}
                    disabled={autoExtractSummary===1?true:false}
                />
                <div style={{alignSelf: "flex-end", marginLeft: '8px', whiteSpace: "nowrap"}}>
                    <Checkbox
                        checked={autoExtractSummary===1}
                        onChange={e => {
                            if (e.target.checked) {
                                if (value) {
                                    confirm({
                                        title:  '勾选会覆盖当前摘要，您确定要自动提取吗？',
                                        onOk: () => {
                                            this.onChecked({onChange,field,e})
                                        },
                                        onCancel: () => {
                                        },
                                    });
                                } else {
                                    this.onChecked({onChange,field,e})
                                }
                                return
                            }
                            onChange('autoExtractSummary', e.target.checked?1:0);
                        }}>自动提取</Checkbox>
                </div>
                <style>
                    {
                        `
                        .rmt-textarea{
                         resize:none;
                         max-height: 94px;
                        }
                        `
                    }
                </style>
            </div>
        )
    }

    onChecked = ({onChange, field, e}) => {
        let val="";
        val = this.props.contentText && this.props.contentText.length ? this.props.contentText : "";
        if(mustFilterSummary) {
            val = val.replace(/\s/g,'')
        }
        if (val && val.length > automaticMaxLength) {
            val = val.substring(0, automaticMaxLength) + "..."
        }
        onChange('autoExtractSummary', e.target.checked?1:0);
        onChange(field, val);
    };

}